/* Tile-based free-gift picker — runtime handlers.

   Two cart-submission paths exist in this theme:

   - PDP: assets/theme.js#actionAddToCart2 uses window.fetch('/cart/add.js').
     The bundle (main-B4AWxX29.js) monkeypatches window.fetch and, after
     every /cart/add response, reads #option-free-products to add the chosen
     gift. So on PDP we just swap our hidden select's id to plain
     'option-free-products' synchronously before submit; the monkeypatch
     handles the rest.

   - Card grid/list/sidebar: theme.js#actionAddToCart uses Shopify.addItem,
     which routes through jQuery $.ajax (XHR) — NOT window.fetch. The
     monkeypatch never fires, so the gift add never happens. To make cards
     work, we take over the click ourselves and POST a single multi-item
     /cart/add.js with the main product + chosen gift, then open Halo's cart
     drawer the same way actionAddToCart does (Shopify.getCart →
     cart-sidebar-show body class → halo.updateSidebarCart). Using XHR for
     the multi-item add also bypasses the fetch monkeypatch, so the gift
     isn't added twice.

   Cart logic, /cart/add behaviour, the discount path, and the bundle remain
   untouched — the discount is server-side based on cart contents.

   The card-scope picker uses a two-step state machine via data-state on the
   picker root: first ATC click expands; second click submits. The capture
   phase guarantees our handler runs before the bundle's delegated jQuery
   listener on $doc, so our preventDefault + stopImmediatePropagation
   reliably suppresses the legacy single-item add. */

(function () {
  if (window.__rudeGiftPickerBound) return;
  window.__rudeGiftPickerBound = true;

  var mobileMql = window.matchMedia('(max-width: 599px)');

  function labelForGift(giftName) {
    var prefix = mobileMql.matches ? 'Add' : 'Add to cart';
    return prefix + ' + ' + giftName;
  }

  function findAtcButton(picker) {
    var scope = picker.closest(
      '.product-item, product-form, .productView, .halo-quickshop, form.variants'
    );
    return scope ? scope.querySelector('[data-btn-addToCart]') : null;
  }

  function updateAtcLabel(picker) {
    var btn = findAtcButton(picker);
    if (!btn) return;
    if (btn.querySelector('svg, img')) return;
    if (!btn.dataset.rudeGiftOriginalLabel) {
      btn.dataset.rudeGiftOriginalLabel = btn.textContent.trim();
    }
    var selectedTile = picker.querySelector('[data-gift-tile].is-selected');
    var giftName = selectedTile ? selectedTile.getAttribute('data-gift-name') : null;
    if (!giftName) return;
    btn.textContent = labelForGift(giftName);
  }

  // setLoading / openCartDrawer / addItems are now provided by
  // assets/rude-cart-add.js (window.RudeCartAdd). The Trial Hero inline
  // picker on /collections/all uses the same helpers.

  function submitCardWithGift(btn, picker) {
    var form = btn.closest('form');
    if (!form) return;
    var mainIdInput = form.querySelector('input[name="id"]');
    var mainId = mainIdInput ? parseInt(mainIdInput.value, 10) : 0;
    if (!mainId) return;
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var items = [{ id: mainId, quantity: qty }];
    var giftSelect = picker.querySelector('select[data-rude-gift-select]');
    if (giftSelect && giftSelect.value && giftSelect.value !== 'none') {
      var giftId = parseInt(giftSelect.value, 10);
      if (giftId > 0) items.push({ id: giftId, quantity: 1 });
    }

    if (!window.RudeCartAdd) {
      console.error('rude-gift-picker: RudeCartAdd helper missing');
      return;
    }

    if (document.body.classList.contains('template-cart')) {
      // Match theme.js behaviour on the /cart page — redirect after add.
      window.RudeCartAdd.addItems(items, btn, function () {
        if (window.halo && typeof window.halo.redirectTo === 'function' && window.routes) {
          window.halo.redirectTo(window.routes.cart);
        } else {
          window.location.reload();
        }
      });
      return;
    }

    window.RudeCartAdd.addItems(items, btn, window.RudeCartAdd.openCartDrawer);
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-gift-tile]');
    if (!tile) return;
    var picker = tile.closest('.rude-gift-picker');
    if (!picker) return;
    var select = picker.querySelector('select[data-rude-gift-select]');
    if (!select) return;
    var value = tile.getAttribute('data-gift-value');
    picker.querySelectorAll('[data-gift-tile]').forEach(function (t) {
      var isSelected = t === tile;
      t.classList.toggle('is-selected', isSelected);
      t.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });
    if (select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (
      picker.classList.contains('rude-gift-picker--card') &&
      picker.dataset.state === 'expanded'
    ) {
      updateAtcLabel(picker);
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-btn-addToCart]');
      if (!btn) return;
      var scope = btn.closest(
        '.product-item, product-form, .productView, .halo-quickshop, form.variants'
      );
      if (!scope) return;
      var picker = scope.querySelector('.rude-gift-picker');
      if (!picker) return;

      if (picker.classList.contains('rude-gift-picker--card')) {
        if (picker.dataset.state !== 'expanded') {
          picker.classList.remove('is-collapsed');
          picker.classList.add('is-expanded');
          picker.dataset.state = 'expanded';
          updateAtcLabel(picker);
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        // 2nd click — take over the submit. Halo's card ATC uses
        // Shopify.addItem (jQuery XHR), which bypasses the fetch
        // monkeypatch that would otherwise add the gift. Doing the
        // multi-item add ourselves keeps both items atomic.
        e.preventDefault();
        e.stopImmediatePropagation();
        submitCardWithGift(btn, picker);
        return;
      }

      // PDP scope — submit goes through fetch, monkeypatch handles the
      // gift. Just promote this picker's select so the monkeypatch reads it.
      var thisSelect = picker.querySelector('select[data-rude-gift-select]');
      if (!thisSelect) return;
      document.querySelectorAll('select#option-free-products').forEach(function (sel) {
        if (sel !== thisSelect) sel.removeAttribute('id');
      });
      thisSelect.id = 'option-free-products';
    },
    true
  );

  mobileMql.addEventListener('change', function () {
    document
      .querySelectorAll('.rude-gift-picker--card[data-state="expanded"]')
      .forEach(updateAtcLabel);
  });
})();
